import React from 'react';

const ScoreWordRenderer = ({ value }) => {
  return value?.word ? <div dangerouslySetInnerHTML={{ __html: value.word }} /> : null;
};

export default ScoreWordRenderer;
